import { styled } from "@mui/material";
import { NavLink } from "react-router";

import { DEFAULT_SKEW } from "@citrine/utils/skew";

export const Step = styled(NavLink)(({ theme }) => ({
  color: "inherit",
  display: "flex",
  flex: 1,
  flexDirection: "column",
  justifyContent: "center",
  textAlign: "center",
  textDecoration: "none",
  width: "25%",
  transform: `skew(${-DEFAULT_SKEW}rad)`,
  transformOrigin: "bottom",

  "&.active": {
    backgroundColor: theme.palette.grey[700],
  },
}));

export const Title = styled("div")(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "row",
  flexShrink: 0,
  fontWeight: theme.typography.fontWeightMedium,
  gap: theme.spacing(1),
  justifyContent: "center",
  paddingRight: theme.spacing(2), // visual centering
  transform: `skew(${DEFAULT_SKEW}rad)`,
}));
